module.exports = __webpack_public_path__ + "static/media/tab_bg.e680077b.webm";